var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1020,
    height: 320,
    viewBox: "0 0 1020 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logo_Colored"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1020,
    height: 320
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Colored",
    "data-name": "Logo Colored",
    clipPath: "url(#clip-Logo_Colored)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rentificial_flat_color",
    transform: "translate(5.898 -239.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M162.535,96.139A6.4,6.4,0,0,1,164.1,100.2a5.217,5.217,0,0,1-5.6,5.409,5.921,5.921,0,0,1-5.153-2.593l-22.4-27.078H106.939V99.852a5.217,5.217,0,0,1-5.633,5.761,5.281,5.281,0,0,1-5.729-5.761V35.07a5.537,5.537,0,0,1,6.209-5.761h35.208c17.188,0,26.374,7.906,26.374,22.693,0,12.8-6.4,20.644-19.2,22.693v.224Zm-26.6-30.023c10.242,0,16-4.641,16-13.443s-5.633-13.539-16-13.539h-29V66.117Z",
    transform: "translate(223.434 311.702)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M180.85,95.049a4.929,4.929,0,0,1,5.6,4.961c0,3.2-2.144,4.865-5.6,4.865h-54.8a5.537,5.537,0,0,1-6.209-5.761V35.1a5.537,5.537,0,0,1,6.209-5.761h54.8c3.457,0,5.6,1.792,5.6,4.865a4.929,4.929,0,0,1-5.6,4.961H131.207V61.954h40.681c3.585,0,5.729,1.824,5.729,4.865s-2.144,4.961-5.729,4.961H131.207V95.145Z",
    transform: "translate(277.278 311.768)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M214.948,34.715v64.91a5.889,5.889,0,0,1-6.209,6.4,8,8,0,0,1-6.4-2.817L154.679,46.685h-.256v53.74a5.121,5.121,0,0,1-5.537,5.633,5.217,5.217,0,0,1-5.633-5.633V35.611a6.113,6.113,0,0,1,6.4-6.4,7.81,7.81,0,0,1,6.4,2.817l47.562,56.332h.224V34.715a5.121,5.121,0,0,1,5.505-5.633,5.217,5.217,0,0,1,5.6,5.633Z",
    transform: "translate(329.167 311.257)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M236.866,29.28c3.457,0,5.6,1.792,5.6,4.865a4.929,4.929,0,0,1-5.6,4.961H210.62V99.919a5.217,5.217,0,0,1-5.633,5.761,5.281,5.281,0,0,1-5.729-5.761V39.106H172.852a4.929,4.929,0,0,1-5.6-4.961c0-3.2,2.144-4.865,5.6-4.865Z",
    transform: "translate(382.429 311.731)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M203.657,34.846V100.3a5.185,5.185,0,0,1-5.6,5.761,5.281,5.281,0,0,1-5.729-5.761V34.846a5.281,5.281,0,0,1,5.729-5.761,5.185,5.185,0,0,1,5.6,5.761Z",
    transform: "translate(437.77 311.254)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M259.575,29.309c3.457,0,5.6,1.792,5.6,4.865a4.929,4.929,0,0,1-5.6,4.961H211.117V63.62h39.753c3.457,0,5.6,1.824,5.6,4.961s-2.144,4.865-5.6,4.865H211.117V99.852a5.185,5.185,0,0,1-5.6,5.761,5.281,5.281,0,0,1-5.729-5.761V35.07A5.537,5.537,0,0,1,206,29.309Z",
    transform: "translate(454.488 311.702)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M233.559,34.846V100.3a5.217,5.217,0,0,1-5.633,5.761A5.281,5.281,0,0,1,222.2,100.3V34.846a5.281,5.281,0,0,1,5.729-5.761,5.217,5.217,0,0,1,5.633,5.761Z",
    transform: "translate(503.973 311.254)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M304.022,92.074c-6.561,9.026-18.628,15.107-33.9,15.107-24.485,0-41.417-16-41.417-39.144S245.642,28.86,270.127,28.86c13.955,0,25.318,4.961,32.711,13.763a5.377,5.377,0,0,1,1.184,3.393,5.217,5.217,0,0,1-5.505,5.185,5.7,5.7,0,0,1-4.641-2.144,29.126,29.126,0,0,0-23.621-10.4c-17.8,0-29.958,11.971-29.958,29.382s12.163,29.35,29.958,29.35a29.03,29.03,0,0,0,24.581-11.523,5.345,5.345,0,0,1,4.641-2.144,5.153,5.153,0,0,1,5.377,5.185,5.41,5.41,0,0,1-.832,3.169Z",
    transform: "translate(518.716 310.806)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M266.387,34.846V100.3a5.185,5.185,0,0,1-5.6,5.761,5.281,5.281,0,0,1-5.729-5.761V34.846a5.281,5.281,0,0,1,5.729-5.761,5.185,5.185,0,0,1,5.6,5.761Z",
    transform: "translate(577.584 311.254)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M334.69,64.45v36.232a5.665,5.665,0,1,1-11.33,0V82.758H273.2V100.81a5.537,5.537,0,1,1-11.074,0V64.45c0-23.045,13.123-35.56,36.264-35.56S334.69,41.309,334.69,64.45ZM323.359,64c0-16.74-8.834-25.317-25.061-25.317S273.2,47.262,273.2,64v9.026h50.155Z",
    transform: "translate(593.203 310.872)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M347.567,95.563a4.929,4.929,0,0,1,5.6,4.961c0,3.2-2.144,4.865-5.6,4.865h-53a5.537,5.537,0,0,1-6.209-5.761V34.845a5.313,5.313,0,0,1,5.761-5.761,5.185,5.185,0,0,1,5.6,5.761V95.659Z",
    transform: "translate(650.869 311.254)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M118.194,83.11a.792.792,0,0,1-.544,1.344.9.9,0,0,1-.736-.352l-9.186-10.754H97.133V83.654a.788.788,0,1,1-1.568,0V59.137a.768.768,0,0,1,.864-.832h13.347c5.537,0,8.578,2.657,8.578,7.49s-3.1,7.554-8.578,7.554h0ZM109.52,71.971c4.641,0,7.106-2.112,7.106-6.145s-2.465-6.145-7.106-6.145H97.133V71.971Z",
    transform: "translate(223.369 375.59)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M125.155,82.95c.512,0,.8.256.8.7s-.288.672-.8.672H104.766a.768.768,0,0,1-.864-.832V59.137a.768.768,0,0,1,.864-.832h20.388c.512,0,.8.256.8.672a.7.7,0,0,1-.8.7H105.471V70.467h16.676c.48,0,.768.256.768.64a.7.7,0,0,1-.768.7H105.471V82.95Z",
    transform: "translate(241.856 375.59)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M135.433,59.065V83.71a.832.832,0,0,1-.9.9,1.152,1.152,0,0,1-.864-.416L113.476,60.7h0V83.71a.788.788,0,1,1-1.568,0V59.161a.8.8,0,0,1,.864-.928,1.152,1.152,0,0,1,.9.448l20.2,23.4h0V59.065a.768.768,0,1,1,1.536,0Z",
    transform: "translate(259.586 375.438)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M144.073,58.3c.48,0,.768.256.768.672a.672.672,0,0,1-.768.7h-10.85V83.617a.736.736,0,0,1-.768.832c-.544,0-.768-.32-.768-.832V59.676H120.772c-.512,0-.832-.256-.832-.7s.32-.672.832-.672Z",
    transform: "translate(277.417 375.595)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M152.09,70.1V83.926c0,.512-.256.832-.768.832a.736.736,0,0,1-.768-.832v-7.97H129.493v7.97a.788.788,0,1,1-1.568,0V70.1c0-7.81,4.353-11.939,12.1-11.939S152.09,62.289,152.09,70.1Zm-1.536,0a10.53,10.53,0,0,0-21.061,0v4.513h21.093Z",
    transform: "translate(295.099 375.287)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M157.537,83.055a.672.672,0,0,1,.768.7c0,.416-.288.672-.768.672h-19.78a.768.768,0,0,1-.864-.832V59.018a.768.768,0,1,1,1.536,0V83.055Z",
    transform: "translate(314.977 375.485)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M175.437,59.192V83.773c0,.512-.256.832-.768.832a.736.736,0,0,1-.768-.832v-22.6h0L162.058,78.524a.928.928,0,0,1-.832.48.96.96,0,0,1-.832-.48L148.551,61.113h0V83.773c0,.512-.256.832-.768.832a.736.736,0,0,1-.768-.832V59.192a.864.864,0,0,1,.928-.96,1.024,1.024,0,0,1,.96.544l12.419,18.276,12.387-18.244a1.184,1.184,0,0,1,1.024-.576.832.832,0,0,1,.7.96Z",
    transform: "translate(337.423 375.439)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M181.443,70.1V83.926c0,.512-.224.832-.768.832a.736.736,0,0,1-.768-.832v-7.97H158.846v7.97a.768.768,0,0,1-1.536,0V70.1c0-7.81,4.321-11.939,12.1-11.939S181.443,62.289,181.443,70.1Zm-1.536,0c0-7.01-3.681-10.562-10.5-10.562A9.6,9.6,0,0,0,158.846,70.1v4.513h21.061Z",
    transform: "translate(360.248 375.287)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M189.823,59.065V83.71a.832.832,0,0,1-.9.9,1.152,1.152,0,0,1-.864-.416L167.866,60.7h0V83.71a.788.788,0,1,1-1.568,0V59.161a.8.8,0,0,1,.864-.928,1.152,1.152,0,0,1,.9.448l20.2,23.4h0V59.065a.768.768,0,0,1,1.536,0Z",
    transform: "translate(380.143 375.438)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M199.225,70.1V83.926a.8.8,0,1,1-1.568,0v-7.97H176.6v7.97a.768.768,0,1,1-1.536,0V70.1c0-7.81,4.321-11.939,12.1-11.939S199.225,62.289,199.225,70.1Zm-1.568,0c0-7.01-3.681-10.562-10.5-10.562A9.6,9.6,0,0,0,176.6,70.1v4.513h21.061Z",
    transform: "translate(399.591 375.287)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M209.914,72.215a.768.768,0,0,1,.864.8h0c0,7.074-5.473,11.939-13.507,11.939a13.411,13.411,0,1,1,0-26.822,13.827,13.827,0,0,1,11.17,4.8.736.736,0,0,1-.576,1.216.768.768,0,0,1-.64-.288,12.227,12.227,0,0,0-9.89-4.385,12.067,12.067,0,0,0,0,24.133c6.914,0,11.682-4.1,11.971-10.178H200.76a.672.672,0,0,1-.768-.7c0-.416.288-.64.768-.64Z",
    transform: "translate(419.105 375.187)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M214.615,82.95c.512,0,.8.256.8.7s-.288.672-.8.672H194.226a.768.768,0,0,1-.864-.832V59.137a.768.768,0,0,1,.864-.832h20.388c.512,0,.8.256.8.672a.7.7,0,0,1-.8.7H194.931V70.467h16.676c.48,0,.768.256.768.64a.7.7,0,0,1-.768.7H194.931V82.95Z",
    transform: "translate(440.145 375.59)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M229.869,59.192V83.773c0,.512-.224.832-.768.832a.736.736,0,0,1-.768-.832v-22.6h0L216.49,78.524a.928.928,0,0,1-1.632,0L202.983,61.112h0V83.773a.788.788,0,1,1-1.568,0V59.192a.9.9,0,0,1,.96-.96,1.024,1.024,0,0,1,.928.544l12.419,18.276,12.387-18.244a1.216,1.216,0,0,1,1.024-.576C229.613,58.232,229.869,58.616,229.869,59.192Z",
    transform: "translate(458.007 375.439)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M233.155,82.947a.672.672,0,0,1,.768.7c0,.416-.288.672-.768.672h-20.42a.8.8,0,0,1-.864-.832V59.134a.8.8,0,0,1,.864-.832h20.42c.48,0,.768.256.768.672a.672.672,0,0,1-.768.7H213.439V70.464h16.676c.48,0,.768.256.768.64a.7.7,0,0,1-.768.7H213.439V82.947Z",
    transform: "translate(481.175 375.593)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M243.381,59.065V83.71a.832.832,0,0,1-.9.9,1.056,1.056,0,0,1-.832-.416L221.456,60.7h0V83.71a.788.788,0,1,1-1.568,0V59.161a.8.8,0,0,1,.864-.928,1.152,1.152,0,0,1,.9.448l20.2,23.4h0V59.065a.736.736,0,0,1,.768-.832C243.125,58.232,243.381,58.552,243.381,59.065Z",
    transform: "translate(498.927 375.438)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M252.043,58.3c.48,0,.768.256.768.672a.672.672,0,0,1-.768.7h-10.85V83.617a.736.736,0,0,1-.768.832c-.512,0-.768-.32-.768-.832V59.676H228.742c-.512,0-.832-.256-.832-.7s.32-.672.832-.672Z",
    transform: "translate(516.739 375.595)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M250.345,70.509c8.77,0,11.811,2.016,11.811,6.753s-4.353,7.714-11.426,7.714c-6.113,0-10.178-1.632-11.939-4.417a.731.731,0,0,1,.608-1.184.8.8,0,0,1,.7.352c1.632,2.561,5.313,3.9,10.658,3.9,6.049,0,9.858-2.465,9.858-6.4s-2.529-5.089-10.306-5.185c-8.418,0-11.3-1.792-11.3-6.145s4.353-7.714,11.2-7.714a13.315,13.315,0,0,1,10.594,3.841.64.64,0,0,1,.16.48.776.776,0,0,1-1.376.416,11.906,11.906,0,0,0-9.41-3.393c-5.953,0-9.6,2.433-9.6,6.4C240.583,69.229,243.015,70.509,250.345,70.509Z",
    transform: "translate(540.495 375.228)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M260.814,58.185A13.411,13.411,0,1,1,246.763,71.6a13.091,13.091,0,0,1,14.051-13.411Zm0,25.606a12.067,12.067,0,1,0-12.451-12.067,11.683,11.683,0,0,0,12.451,11.939Z",
    transform: "translate(559.375 375.262)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M277.523,58.3c.48,0,.768.256.768.672a.672.672,0,0,1-.768.7h-19.2V71.043h16.324c.512,0,.8.224.8.64a.7.7,0,0,1-.8.7H258.319V83.622a.768.768,0,0,1-1.536,0V59.137a.768.768,0,0,1,.864-.832Z",
    transform: "translate(581.428 375.59)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M287.723,58.3c.48,0,.768.256.768.672a.672.672,0,0,1-.768.7h-10.85V83.617a.736.736,0,0,1-.768.832c-.544,0-.768-.32-.768-.832V59.676H264.422c-.512,0-.832-.256-.832-.7s.32-.672.832-.672Z",
    transform: "translate(596.416 375.595)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M310.479,58.97a1.089,1.089,0,0,1,0,.512l-9.218,24.485a.882.882,0,0,1-1.7,0l-8.546-22.4h0l-8.514,22.4a.864.864,0,0,1-.864.64.832.832,0,0,1-.832-.64L271.59,59.546a2.754,2.754,0,0,1,0-.576.768.768,0,0,1,.864-.736.736.736,0,0,1,.736.544l8.546,22.885h0l8.61-22.885a.7.7,0,0,1,.736-.544.736.736,0,0,1,.768.544l8.642,22.949h0l8.546-22.917a.736.736,0,0,1,.736-.576.768.768,0,0,1,.7.736Z",
    transform: "translate(613.99 375.437)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M308.615,70.1V83.926a.8.8,0,1,1-1.568,0v-7.97h-21.06v7.97a.768.768,0,0,1-1.536,0V70.1c0-7.81,4.321-11.939,12.1-11.939S308.615,62.289,308.615,70.1Zm-1.568,0c0-7.01-3.681-10.562-10.5-10.562A9.6,9.6,0,0,0,285.986,70.1v4.513h21.06Z",
    transform: "translate(642.323 375.287)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M315.971,83.11a.7.7,0,0,1,.256.576.768.768,0,0,1-.768.768.864.864,0,0,1-.736-.352l-9.218-10.754H294.943V83.654a.788.788,0,1,1-1.568,0V59.137a.768.768,0,0,1,.864-.832h13.187c5.569,0,8.61,2.657,8.61,7.49s-3.009,7.554-8.514,7.554h0Zm-8.642-11.138c4.641,0,7.106-2.112,7.106-6.145s-2.465-6.145-7.106-6.145H294.943V71.971Z",
    transform: "translate(661.949 375.591)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M322.921,82.95c.512,0,.768.256.768.7s-.256.672-.768.672H302.6a.768.768,0,0,1-.864-.832V59.137a.768.768,0,0,1,.864-.832h20.388c.512,0,.768.256.768.672a.675.675,0,0,1-.768.7H303.237V70.467h16.676c.48,0,.768.256.768.64a.7.7,0,0,1-.768.7H303.237V82.95Z",
    transform: "translate(680.349 375.591)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M314.243,38.064a6.152,6.152,0,1,1-.1,0m0-8.994a14.979,14.979,0,1,0,15.011,14.947A14.979,14.979,0,0,0,314.147,29.07Z",
    transform: "translate(674.783 311.269)",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(4.102 249.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M20,0H280a20,20,0,0,1,20,20V280a20,20,0,0,1-20,20H20A20,20,0,0,1,0,280V20A20,20,0,0,1,20,0Z",
    fill: "#2e78bc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M140.3,24.83a14.851,14.851,0,0,1,4.513,29.03V69.224h16a13.187,13.187,0,0,1,8.1,2.785l8.45,6.689,5.345-5.985a14.851,14.851,0,1,1,6.913,5.729L184.6,84.267l10.914,8.706a4,4,0,0,0,2.5.864h19.556a12.963,12.963,0,0,1,12.995,12.8v5.281h7.97a14.883,14.883,0,1,1,0,8.962h-8v11.555a13,13,0,0,1-12.995,12.8h-8.162a14.883,14.883,0,1,1,0-8.962h8.162a4,4,0,0,0,4-4V121.011h-53.8v11.426a13,13,0,0,1-12.995,12.8h-9.922v36.808a14.947,14.947,0,1,1-8.994,0V145.4h-10.5a13,13,0,0,1-12.995-12.8V121.011H59.065v11.426a4,4,0,0,0,4,4h8.194a14.851,14.851,0,1,1,0,8.962H63.065a13,13,0,0,1-12.995-12.8V121.011H42.1a14.851,14.851,0,1,1,0-8.962h7.97v-5.281a12.963,12.963,0,0,1,12.995-12.8H82.558a3.873,3.873,0,0,0,2.465-.864l10.786-8.482L90.719,78.73a15.555,15.555,0,0,1-5.217.928,14.851,14.851,0,1,1,14.947-15.075,14.563,14.563,0,0,1-2.625,8.386l5.057,5.889,8.8-6.945a13.027,13.027,0,0,1,8.034-2.785h16V53.764a14.851,14.851,0,0,1,4.481-29.03m0,20.772a5.921,5.921,0,1,0-5.921-5.921,5.921,5.921,0,0,0,5.921,5.921m54.8,25a5.918,5.918,0,1,1,.064,0M85.47,70.5a5.905,5.905,0,1,1,.032,0m59.309,41.545h13.923v-6.882a12.963,12.963,0,0,1,3.2-8.418l9.6-11.266-8.194-6.4a4.033,4.033,0,0,0-2.5-.832h-16v33.8m-23.493,0h14.5V78.186h-16a4.033,4.033,0,0,0-2.465.832l-8.546,6.721,9.6,11.01a13,13,0,0,1,3.2,8.418v6.881m46.41,0h53.484v-5.281a4,4,0,0,0-4-3.969H197.975a12.8,12.8,0,0,1-8.066-2.817l-11.33-8.93-9.89,11.522a4.129,4.129,0,0,0-.96,2.593v6.882m-108.664,0h53.228v-6.881a4.129,4.129,0,0,0-.96-2.593l-9.6-11.266-11.042,8.706a13.187,13.187,0,0,1-8.066,2.785H63.065a4,4,0,0,0-4,3.969v5.281m193.674,10.4a5.97,5.97,0,1,0-.1,0m-224.881,0a5.921,5.921,0,1,0-5.921-5.921,5.921,5.921,0,0,0,5.921,5.921m116.953,13.987h9.922a4,4,0,0,0,4-4V121.011H144.811v15.427m-19.492,0h10.5V121.011h-14.5v11.426a4,4,0,0,0,4,4m69.807,10.37a6.126,6.126,0,1,0-.064,0m-109.656,0a5.921,5.921,0,1,0-5.921-5.889,5.921,5.921,0,0,0,5.921,5.889m54.892,55.4a5.921,5.921,0,1,0-5.921-5.889,5.921,5.921,0,0,0,5.921,5.889m0-186.408a23.813,23.813,0,0,0-13.475,43.5v.9h-7.106a21.921,21.921,0,0,0-10.335,2.591A23.909,23.909,0,1,0,72.86,84.811H63.065A22.085,22.085,0,0,0,42.9,97.934a23.781,23.781,0,1,0-1.5,38.216A21.989,21.989,0,0,0,63.065,154.2h2.657a23.941,23.941,0,0,0,42.953-7.586,21.989,21.989,0,0,0,16.644,7.586h1.5v22.4a23.621,23.621,0,0,0-10.434,19.684A23.941,23.941,0,1,0,153.9,176.607V154.2h.928a21.893,21.893,0,0,0,17.06-8.1,23.973,23.973,0,0,0,43.017,8.1h2.625A21.989,21.989,0,0,0,239.2,136.086a24.229,24.229,0,0,0,13.539,4.129A23.813,23.813,0,1,0,237.7,97.87a22.085,22.085,0,0,0-20.164-13.123h-9.794a23.845,23.845,0,1,0-36.52-22.021,21.957,21.957,0,0,0-10.37-2.593H153.9v-.9a23.813,23.813,0,0,0-13.507-43.5Z",
    transform: "translate(9.647 31.993)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColored);
export default __webpack_public_path__ + "static/media/logo-colored.d776a6415e0cc302b717dda98ae7a0fb.svg";
export { ForwardRef as ReactComponent };